module.exports = __webpack_public_path__ + "static/media/download-craneo-dental.3afa1bfd.png";